import { Avatar as AvatarComponent, AvatarFallback, AvatarImage } from '@components/ui/avatar';
import { cn } from '@lib/utils';

interface AvatarProps {
  image?: string | null | undefined;
  name?: string;
  className?: string;
  /**
   * Optional placeholder image to use when no image is provided
   */
  placeholderImage?: string;
}

export const Avatar = ({ image, name = '', className, placeholderImage = '/avatar.webp' }: AvatarProps) => {
  const shouldShowFallback = !image && name;
  const firstTwoChars = name?.slice(0, 2) || '';

  return (
    <AvatarComponent className={cn('', className)}>
      {(image || (!name && placeholderImage)) && (
        <AvatarImage src={image || (!name ? placeholderImage : undefined)} alt={name || 'Avatar'} />
      )}
      {shouldShowFallback && <AvatarFallback className="bg-foreground/10">{firstTwoChars}</AvatarFallback>}
    </AvatarComponent>
  );
};
